module.exports = __webpack_public_path__ + "static/media/img-promo-time.c284c2f8.png";